import Historyc from "./GraficoHistoryc";
import Layout from "../../../components/layout";



export default function DashHistorico() {
  return (
    <Layout>
      <Historyc/>
    </Layout>)
}
